export default __webpack_public_path__ + "static/media/cart.e3f20744.svg";